export const inputStyles = {
  root: {
    width: '100%',
    background: '#fff',
    border: '1px solid #DFE8F0',
    borderRadius: 4,
    fontSize: 12,
    color: '#172B4D',
  },
  input: {
    height: 'auto',
    padding: '0 12px',
    lineHeight: '30px',
  },
};
